export default __webpack_public_path__ + "static/media/jewelry-clear-summer.5eb10cdf.png";